import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Maintennancosdc() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/", { replace: true });
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg,#0f2027,#203a43,#2c5364)",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
      }}
    >
      <div>
        <h1>🚧 Page Under Maintenance</h1>
        <p>Redirecting to homepage...</p>
      </div>
    </div>
  );
}
